export enum ModalNameEnum {
  SELECT_PARTNER,
  BILLING_INFO,
  REMARK,
  DELIVERY_INFO,
  EDIT_POSITION
}
